import { TipoIndirizzo } from 'server/schema/integrations/pdnd/schema/schemas';

export function getCitizenAddress(address?: TipoIndirizzo): string | undefined {
  if (!address) {
    return undefined;
  }
  return (
    (address?.toponimo?.specie ?? '') +
    ' ' +
    (address?.toponimo?.denominazioneToponimo ?? '') +
    ' ' +
    (address?.numeroCivico?.numero ?? '')
    // ' ' +
    // (address?.numeroCivico?.civicoInterno?.interno1 ?? '') +
    // ', ' +
    // (address?.comune?.nomeComune ?? '') +
    // ' (' +
    // (address?.comune?.siglaProvinciaIstat ?? '') +
    // ')'
  );
}
